import React from 'react';
import { Box, Typography } from '@mui/material';

function formatUser(u) {
  if (!u) return '—';
  const name = [u.first_name, u.last_name].filter(Boolean).join(' ').trim();
  return name || u.email || '—';
}

function formatDt(d) {
  if (!d) return '—';
  try {
    return new Date(d).toLocaleString();
  } catch {
    return '—';
  }
}

/**
 * Shows created / last-updated user and timestamps from API (snake_case or nested creator/updater).
 */
export default function RecordAuditMeta({
  creator,
  updater,
  created_at: createdAtProp,
  updated_at: updatedAtProp,
  createdAt: createdAtCamel,
  updatedAt: updatedAtCamel,
  sx = {}
}) {
  const createdAt = createdAtProp ?? createdAtCamel;
  const updatedAt = updatedAtProp ?? updatedAtCamel;

  return (
    <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider', ...sx }}>
      <Typography variant="caption" color="text.secondary" display="block">
        Created {formatDt(createdAt)} · {formatUser(creator)}
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block">
        Last updated {formatDt(updatedAt)} · {formatUser(updater)}
      </Typography>
    </Box>
  );
}
